// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminReviewsPageContainer {
  padding: 16px;
  width: 80vw;
}

.adminReviewsPageHeader {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.adminReviewsPageFilters {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.formControl {
  display: flex;
  flex-direction: column;
}

.adminReviewsPageContainer .labelText {
  color: #247a97;
  font-size: 2rem;
  font-weight: bold;
}

.label {
  font-size: 1.25rem;
  font-weight: bold;
}

.selectInput {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1.25rem;
  background-color: white;
}

.adminReviewsPageTableWrapper {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
}

.adminReviewsTable {
  width: 100%;
  border-collapse: collapse;
}

.adminReviewsTable thead {
  background-color: #e2e2e2;
}

.adminReviewsTable thead th {
  font-size: 1.5rem;
  padding: 8px;
  color: #247a97;
}

.adminReviewsTable tbody td {
  font-size: 1.25rem;
  padding: 8px;
  text-align: left;
}

.reviewRow {
  border: 1px solid #ccc;

  &:hover {
    background-color: #e2e2e2;
    transition: ease 0.3s;
    transform: scale(0.95);
  }
}

.userContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatarContainer img {
  border-radius: 50%;
  width: 48px;
  height: 48px;
}

.adminReviewsPageContainer .username,
.adminReviewsPageContainer .productLink,
.adminReviewsPageContainer .reviewDescription {
  color: #333;
  font-size: 1.25rem;
}

.adminReviewsPageContainer .productLink {
  justify-content: left;
  display: flex;
  align-items: self-start;
}

.adminReviewsPageContainer .reviewDescription {
  font-style: normal;
}

/* .deleteButton {
  padding: 8px 16px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.deleteButton:hover {
  background-color: #ff7875;
} */

.pagination {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.pagination li {
  margin-left: 1rem;
  margin-right: 1rem;
}

.pagination .btn-sm {
  padding: 8px;
  font-size: 1rem;
  margin: 0 4px;
  border-radius: 4px;
}

.pagination .btn-sm:hover {
  background-color: #e2e2e2;
}

.readMoreButton {
  background: none;
  border: none;
  color: #247a97;
  cursor: pointer;
}

@media (max-width: 991px) {
  .adminReviewsPageTableWrapper .adminReviewsTable th {
    font-size: 2rem;
  }

  .adminReviewsPageTableWrapper .adminReviewsTable td {
    font-size: 1.25rem;
  }

  .adminReviewsPageTableWrapper .username {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminReviewsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;;EAEtB;IACE,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".adminReviewsPageContainer {\n  padding: 16px;\n  width: 80vw;\n}\n\n.adminReviewsPageHeader {\n  color: #ffffff;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.adminReviewsPageFilters {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  background-color: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.formControl {\n  display: flex;\n  flex-direction: column;\n}\n\n.adminReviewsPageContainer .labelText {\n  color: #247a97;\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.label {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.selectInput {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 1.25rem;\n  background-color: white;\n}\n\n.adminReviewsPageTableWrapper {\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.adminReviewsTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.adminReviewsTable thead {\n  background-color: #e2e2e2;\n}\n\n.adminReviewsTable thead th {\n  font-size: 1.5rem;\n  padding: 8px;\n  color: #247a97;\n}\n\n.adminReviewsTable tbody td {\n  font-size: 1.25rem;\n  padding: 8px;\n  text-align: left;\n}\n\n.reviewRow {\n  border: 1px solid #ccc;\n\n  &:hover {\n    background-color: #e2e2e2;\n    transition: ease 0.3s;\n    transform: scale(0.95);\n  }\n}\n\n.userContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.avatarContainer img {\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n}\n\n.adminReviewsPageContainer .username,\n.adminReviewsPageContainer .productLink,\n.adminReviewsPageContainer .reviewDescription {\n  color: #333;\n  font-size: 1.25rem;\n}\n\n.adminReviewsPageContainer .productLink {\n  justify-content: left;\n  display: flex;\n  align-items: self-start;\n}\n\n.adminReviewsPageContainer .reviewDescription {\n  font-style: normal;\n}\n\n/* .deleteButton {\n  padding: 8px 16px;\n  background-color: #ff4d4f;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.deleteButton:hover {\n  background-color: #ff7875;\n} */\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.pagination li {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.pagination .btn-sm {\n  padding: 8px;\n  font-size: 1rem;\n  margin: 0 4px;\n  border-radius: 4px;\n}\n\n.pagination .btn-sm:hover {\n  background-color: #e2e2e2;\n}\n\n.readMoreButton {\n  background: none;\n  border: none;\n  color: #247a97;\n  cursor: pointer;\n}\n\n@media (max-width: 991px) {\n  .adminReviewsPageTableWrapper .adminReviewsTable th {\n    font-size: 2rem;\n  }\n\n  .adminReviewsPageTableWrapper .adminReviewsTable td {\n    font-size: 1.25rem;\n  }\n\n  .adminReviewsPageTableWrapper .username {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
